<script>
  import { openFeedbackForm } from '../../../feedbackform';
  import { t,__, __c } from '../../../utils/i18n';
  import { cityServices } from '../../../utils/copy';

  export let d;
  export let isCity;

  const lang = document.documentElement.lang;
  
  const phoneNumber = (d) => {
    // removes anything that's not a digit from the phone number
    return String(d).replace(/\D/g, '');
  };
  
  
  let isException = d.option == "E";

</script>

{#if isCity == false }
  <p>{ t(cityServices, 'StaticA', '') }</p>
  <p class="subhed">
    <span class="label">{__("CONTACT YOUR COUNTY SERVICES")}</span>
  </p>
{:else }
  <p>
    {#if d.id == "Los Angeles"}
      { t(cityServices, 'StaticC', '') }
    {:else}
      { t(cityServices, 'StaticB', '') }
    {/if}
  </p>
{/if}

{#if isException}
  <p>
    {@html d[`${__c('content')}_html`]}
  </p> 
{:else}
  <p>
    {#if d.option == 'A'}
    <!-- If city has website, phone number and app -->
      {@html t(cityServices, 'TemplateA', {
        'id': __(d.id),
        'd.website': d.website,
        'd.phone': phoneNumber(d.phone),
        'd.android': d.android,
        'd.ios': d.ios,
      })}
    {:else if d.option == 'B'}
    <!-- If it has website and phone number -->
      {@html t(cityServices, 'TemplateB', {
        'id': d.id,
        'd.website': d.website,
        'd.phone': phoneNumber(d.phone),
      })}
    {:else if d.option == 'C'}
    <!-- If it has website and app -->
      {@html t(cityServices, 'TemplateC', {
        'id': d.id,
        'd.website': d.website,
        'd.phone': phoneNumber(d.phone),
        'd.android': d.android,
        'd.ios': d.ios,
      })}
    {:else if d.option == 'D'}
    <!-- <If it has website only -->
        {@html t(cityServices, 'TemplateD', {
          'id': d.id,
          'd.website': d.website,
        })}
    {/if}
    <a on:click={openFeedbackForm}>{__("Let us know!")}</a>
  </p>
{/if}